/**
 * PageHeader Component
 * 출금제한 페이지 헤더 (탭 포함)
 */
import React from 'react';
import { AccountTab } from '../hooks/useAccountManagementTab';

interface PageHeaderProps {
    userType: string;
    activeTab: AccountTab;
    onTabChange: (tab: AccountTab) => void;
}

const PageHeader: React.FC<PageHeaderProps> = ({ userType, activeTab, onTabChange }) => (
    <div className="page-header">
        <div className="page-title-container">
            <h1 className="page-title">출금제한</h1>
            {userType === 'HEADQUARTERS' && (
                <div className="title-tabs">
                    <button
                        className={`title-tab ${activeTab === 'partner' ? 'active' : ''}`}
                        onClick={() => onTabChange('partner')}
                    >
                        협력사 출금제한
                    </button>
                    <button
                        className={`title-tab ${activeTab === 'rider' ? 'active' : ''}`}
                        onClick={() => onTabChange('rider')}
                    >
                        라이더 출금제한
                    </button>
                </div>
            )}
        </div>
    </div>
);

export default PageHeader;
